import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { IArticle } from "../../../gatsby-graphql"
import ArticlesList from "../../components/articles-list"
import { IArticlesPage } from "../../../gatsby-graphql"
import { ContentWrapper, SectionWrapper } from "./articles-suggestions-elements"
import { Heading } from "../../ui"
import { SectionProps } from "../section-loader"

interface ArticlesSuggestionsProps extends SectionProps {
  data: {
    heading?: string
    count?: number
    chosenArticles?: IArticle[]
  }
}

const getArticlesPageSlug = (locale: string): string => {
  let { articlesPages } = useStaticQuery(graphql`
    query ArticlesPageQuery {
      articlesPages: allStrapiArticlesPage {
        nodes {
          ...FArticlesPage
        }
      }
    }
  `)
  return (
    articlesPages.nodes.find((i: IArticlesPage) => i.locale === locale).slug ||
    ""
  )
}

const ArticlesSuggestions = ({ data, locale }: ArticlesSuggestionsProps) => {
  locale = locale || "en"
  return (
    <SectionWrapper>
      <ContentWrapper>
        {data.heading && (
          <Heading.H4 textTransform="uppercase">{data.heading}</Heading.H4>
        )}
        <ArticlesList
          params={{
            locale: locale,
            count: data.count || 3,
          }}
          basePath={`/${locale}/${getArticlesPageSlug(locale)}/`}
          layout="vertical"
          showExcerpt={false}
        />
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default ArticlesSuggestions
